/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { formState } from "./form.state";
import { red } from "cms/utils/log/logger"

export const GlobalContentOnlyKey = "global";

const form = createSlice({
    name: "form",

    initialState: formState,

    reducers: {

        // setForm (state, action) {
        //     const form = action.payload;
        //     state.form = form;
        // },
        
        toggleMode (state) {
            const isDisplay = state.mode === "display";
            const nextMode = isDisplay ? "edit" : "display";

            // inverted since we are toggling
            const nextContentOnly = !isDisplay;

            if (isDisplay) {
                state.lastQuestionAdded = null;
            }

            state.contentOnly = {
                [GlobalContentOnlyKey]: nextContentOnly
            };
            state.mode = nextMode;
        },
        // toggleReorderActive (state, action) {
        //     state.reorderActive = action.payload;
        // },

        /**
         * @param state 
         * @param {import('@reduxjs/toolkit').PayloadAction<import('./form.state').FormState['mode']>} action 
         */
        setMode (state, action) {
            state.mode = action.payload;

            if (action.payload === "display") {
                state.lastQuestionAdded = null;
                state.contentOnly = {
                    [GlobalContentOnlyKey]: true
                };
            }
        },
        
        /**
         * @param state 
         * @param {import('@reduxjs/toolkit').PayloadAction<import('./form.state').FormState['mode']>} action 
         */
        setReorderActive (state, action) {
            state.reorderActive = action.payload;
        },
        
        /**
         * @param state 
         * @param {import('@reduxjs/toolkit').PayloadAction<import('./form.state').FormState['mode']>} action 
         */
        setLoadingForm (state, action) {
            state.loadingForm = action.payload;
            const msg = action.payload === true ? "active" : "done";
            console.info(red(`[setLoadingForm] ${msg}`));
        },

        /**
         * @param state 
         * @param {import('@reduxjs/toolkit').PayloadAction<{group: string, enabled: boolean}>} action 
         */
        setContentOnly (state, action) {
            const { group, enabled } = action.payload;
            state.contentOnly[group] = enabled;
        },

        /**
         * @param state 
         * @param {import('@reduxjs/toolkit').PayloadAction<import('./form.state').FormState['modal']>} action 
         */
        setModal (state, action) {
            state.modal = action.payload;
        },

        /**
         * @param state 
         * @param {import('@reduxjs/toolkit').PayloadAction<string | null>} action 
         */
        setLastQuestionAdded (state, action) {
            state.lastQuestionAdded = action.payload;
        },

    },
});

export const formReducer = form.reducer;
export const {
    setContentOnly,
    setLastQuestionAdded,
    setModal,
    setMode,
    setReorderActive,
    setLoadingForm,
    toggleMode,
} = form.actions;
